"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ProductThemeProvider = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _jss = require("jss");

var _ThemeHelper = require("../Utilities/ThemeHelper");

var _jssIncreaseSpecificity = _interopRequireDefault(require("jss-increase-specificity"));

var _notistack = require("notistack");

var _styles2 = require("../SnackBarContent/styles");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var StyledSnackbarProvider = (0, _styles.withStyles)(_styles2.styles)(_notistack.SnackbarProvider);
var muiGenerateClassName = (0, _styles.createGenerateClassName)({
  productionPrefix: ""
});
var addSpecificity = ":not(#\\20)";
var cssResetProps = "{\n\theight: auto;\n\tbackground: none;\n\tbackground-image: none;\n\tbox-shadow: none;\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tfont-family: inherit;\n\tfont-size: inherit;\n\tcolor:inherit;\n}";

var ProductThemeProvider = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ProductThemeProvider, _Component);

  var _super = _createSuper(ProductThemeProvider);

  function ProductThemeProvider(props) {
    var _this;

    (0, _classCallCheck2.default)(this, ProductThemeProvider);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "componentDidUpdate", function (prevProps) {
      var _this$props = _this.props,
          product = _this$props.product,
          primaryHex = _this$props.primaryHex,
          title = _this$props.title,
          cssReset = _this$props.cssReset,
          themeOverride = _this$props.themeOverride,
          maxBreakpoint = _this$props.maxBreakpoint;

      if (prevProps.product !== product || prevProps.primaryHex !== primaryHex || prevProps.title !== title || prevProps.themeOverride !== themeOverride || prevProps.maxBreakpoint !== maxBreakpoint) {
        _this.setState({
          theme: (0, _ThemeHelper.createTheme)(product, primaryHex, title, cssReset, themeOverride, maxBreakpoint)
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "makeSelector", function (selector, selectorSpecificity) {
      var specificity = _this.props.specificity;
      var specificityToAdd = specificity - selectorSpecificity < 0 ? 0 : specificity - selectorSpecificity;
      return specificity ? "".concat(selector).concat(addSpecificity.repeat(specificityToAdd)) : selector;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          cssReset = _this$props2.cssReset,
          maxSnackbars = _this$props2.maxSnackbars,
          SnackbarProps = _this$props2.SnackbarProps,
          prefix = _this$props2.prefix;
      var theme = _this.state.theme;

      if (cssReset) {
        var resetElement = document.getElementById("preamble-reset"); // This selector will catch all jss-styled items

        var preambleSelector = _this.makeSelector("[class^=\"".concat(prefix, "-\"]"), 1); // jQuery UI adds a bunch of classnames, this catches those


        var jqueryUiSelector = "".concat(_this.makeSelector("[class^=\"".concat(prefix, "-\"]"), 2), " [class^=\"ui-\"]"); // Sometimes we have styles on nested JSS selectors

        var preambleNestedSelector = "".concat(_this.makeSelector("[class^=\"".concat(prefix, "-\"]"), 2), " > *");

        if (!resetElement) {
          var head = document.getElementsByTagName("head")[0];
          resetElement = document.createElement("style");
          resetElement.id = "preamble-reset";
          head.insertBefore(resetElement, head.firstChild);
        }

        resetElement.innerHTML = "".concat(preambleSelector, ",").concat(preambleNestedSelector, ",").concat(jqueryUiSelector).concat(cssResetProps);
      }

      var generateClassName = function generateClassName(rule, sheet) {
        return "".concat(prefix, "-").concat(muiGenerateClassName(rule, sheet));
      };

      return /*#__PURE__*/_react.default.createElement(_styles.StylesProvider, {
        jss: _this.jss,
        generateClassName: generateClassName
      }, /*#__PURE__*/_react.default.createElement(_styles.ThemeProvider, {
        theme: theme
      }, /*#__PURE__*/_react.default.createElement(StyledSnackbarProvider, (0, _extends2.default)({
        classes: {
          containerRoot: "prmbl-snackbarProvider",
          root: "prmbl-snackbarProvider-root"
        },
        maxSnack: maxSnackbars
      }, SnackbarProps), children)));
    });
    var _product = props.product,
        _primaryHex = props.primaryHex,
        _title = props.title,
        _specificity = props.specificity,
        _cssReset = props.cssReset,
        _themeOverride = props.themeOverride,
        _maxBreakpoint = props.maxBreakpoint;
    _this.state = {
      theme: (0, _ThemeHelper.createTheme)(_product, _primaryHex, _title, _cssReset, _themeOverride, _maxBreakpoint)
    };
    _this.jss = (0, _jss.create)({
      plugins: (0, _toConsumableArray2.default)((0, _styles.jssPreset)().plugins)
    });

    if (_specificity > 0) {
      _this.jss.use((0, _jssIncreaseSpecificity.default)({
        repeat: _specificity
      }));
    }

    return _this;
  }

  return (0, _createClass2.default)(ProductThemeProvider);
}(_react.Component);

exports.ProductThemeProvider = ProductThemeProvider;
(0, _defineProperty2.default)(ProductThemeProvider, "propTypes", {
  /**
   * The content of the component
   */
  children: _propTypes.default.node,

  /**
   * Sets product colors and logo automatically. Can be overridden by primaryHex and productLogo
   */
  product: _propTypes.default.oneOf(["engageCentral", "engageEvolve", "hr", "clerk", "rec", "ready", "preamble"]),

  /**
   * The hex value for the product's primary color
   */
  primaryHex: _propTypes.default.string,

  /**
   * How much extra specificity should be added to the JSS generated by Preamble
   */
  specificity: _propTypes.default.number,

  /**
   * Sets the title in the theme, used by the Titlebar
   */
  title: _propTypes.default.string,

  /**
   * Whether to include CSS resets for preamble styles. Useful in preventing conflicts in legacy applications.
   */
  cssReset: _propTypes.default.bool,

  /**
   * The maximum number of Snackbars to show at a time
   */
  maxSnackbars: _propTypes.default.number,

  /**
   * Default Snackbar Props (rendered with all Snackbars enqueued)
   */
  SnackbarProps: _propTypes.default.object,

  /**
   * The prefix to generate classNames
   */
  prefix: _propTypes.default.string,

  /**
   * The themeOverride is used to override any of the theme objects.
   * Reference the Theme object at https://preamble-ui.azurewebsites.net/#/Theme to determine what keys you can override
   */
  themeOverride: _propTypes.default.object,

  /**
   * Maximum breakpoint size for the page.
   * It can be: `xs`, `sm`, `md`, `lg`, `xl`
   */
  maxBreakpoint: _propTypes.default.oneOf(["xs", "sm", "md", "lg", "xl"])
});
(0, _defineProperty2.default)(ProductThemeProvider, "defaultProps", {
  primaryHex: "",
  specificity: 0,
  cssReset: false,
  maxSnackbars: 3,
  prefix: "cpp",
  SnackbarProps: {
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "center"
    },
    hideIconVariant: true
  }
});
var _default = ProductThemeProvider;
exports.default = _default;